import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateGlobal(payload) {
    return requestPost(apiPath.GLOBAL.path, payload)
  },

  GetOneGlobal(globalID) {
    return requestGet(`${apiPath.GLOBAL.path}/${globalID}`)
  },

  GetAllGlobal(paging, sorting, filtering) {
    return requestGet(apiPath.GLOBAL.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_cond: filtering.cond,
      f_code: filtering.code,
      f_description: filtering.description
    })
  },

  UpdateGlobal(globalID, payload) {
    return requestPut(`${apiPath.GLOBAL.path}/${globalID}`, payload)
  },

  DeleteGlobal(globalID) {
    return requestDelete(`${apiPath.GLOBAL.path}/${globalID}`)
  },

  GetConfiguration(outletCode) {
    return requestGet(apiPath.GET_CONFIGURATION.path, {
      outletCode,
      f_printingType: '',
      f_status: 1
    })
  },

  ChangeOrderStatus(payload) {
    return requestPut(`${apiPath.CHANGE_ORDER_STATUS.path}`, payload)
  },

  ChangeOrderPaymentMethod(payload) {
    return requestPut(`${apiPath.CHANGE_ORDER_PAYMENT_METHOD.path}`, payload)
  },

  ReconcileOttopayReport(payload) {
    return requestPost(`${apiPath.RECONCILE_OTTOPAY_REPORT.path}`, payload)
  }
}

export default api
